var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRejectWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Reject",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1, 1)",
    fill: "#b8b8ce"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-calendar/Outlined",
    transform: "translate(1.6667, 1.3333)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33333333,0.666666667 C4.33333333,0.298476823 4.03485641,2.22044605e-16 3.66666667,2.22044605e-16 C3.29847692,2.22044605e-16 3,0.298476823 3,0.666666667 L3,1 L2.33333333,1 C1.04466921,1 6.66133815e-16,2.04466845 6.66133815e-16,3.33333308 L6.66133815e-16,11 C6.66133815e-16,12.2886648 1.04466934,13.3333333 2.33333359,13.3333333 L10.3333333,13.3333333 C11.6219971,13.3333333 12.6666667,12.2886648 12.6666667,11 L12.6666667,3.33333333 C12.6666667,2.04466883 11.6219971,1 10.3333333,1 L9.66666667,1 L9.66666667,0.666666667 C9.66666667,0.298476823 9.36818949,2.22044605e-16 9,2.22044605e-16 C8.63181051,2.22044605e-16 8.33333333,0.298476823 8.33333333,0.666666667 L8.33333333,1 L4.33333333,1 L4.33333333,0.666666667 Z M11.3333333,4.05999349 L11.3333333,3.33333333 C11.3333333,2.78104858 10.8856181,2.33333333 10.3333333,2.33333333 L9.66666667,2.33333333 L9.66666667,2.66666667 C9.66666667,3.03485641 9.36818949,3.33333333 9,3.33333333 C8.63181051,3.33333333 8.33333333,3.03485641 8.33333333,2.66666667 L8.33333333,2.33333333 L4.33333333,2.33333333 L4.33333333,2.66666667 C4.33333333,3.03485641 4.03485641,3.33333333 3.66666667,3.33333333 C3.29847692,3.33333333 3,3.03485641 3,2.66666667 L3,2.33333333 L2.33333333,2.33333333 C1.78104846,2.33333333 1.33333333,2.78104858 1.33333333,3.33333308 L1.33333333,4.05999349 L11.3333333,4.05999349 Z M1.33333333,5.39332682 L11.3333333,5.39332682 L11.3333333,11 C11.3333333,11.5522847 10.8856181,12 10.3333333,12 L2.33333359,12 C1.78104871,12 1.33333333,11.5522847 1.33333333,11 L1.33333333,5.39332682 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.4753, 7.498)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0455844123,1.99558441 L5.04558441,1.99558441 C5.34934102,1.99558441 5.59558441,2.2418278 5.59558441,2.54558441 C5.59558441,2.84934102 5.34934102,3.09558441 5.04558441,3.09558441 L0.0455844123,3.09558441 C-0.2581722,3.09558441 -0.504415588,2.84934102 -0.504415588,2.54558441 C-0.504415588,2.2418278 -0.2581722,1.99558441 0.0455844123,1.99558441 Z",
    transform: "translate(2.5456, 2.5456) rotate(45) translate(-2.5456, -2.5456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0455844123,1.99558441 L5.04558441,1.99558441 C5.34934102,1.99558441 5.59558441,2.2418278 5.59558441,2.54558441 C5.59558441,2.84934102 5.34934102,3.09558441 5.04558441,3.09558441 L0.0455844123,3.09558441 C-0.2581722,3.09558441 -0.504415588,2.84934102 -0.504415588,2.54558441 C-0.504415588,2.2418278 -0.2581722,1.99558441 0.0455844123,1.99558441 Z",
    transform: "translate(2.5456, 2.5456) rotate(135) translate(-2.5456, -2.5456)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRejectWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Reject-White.51e28c80fe648aed9ea749a92c332f15.svg";